import { render, staticRenderFns } from "./ChurnTable.vue?vue&type=template&id=8d8c2422&"
import script from "./ChurnTable.vue?vue&type=script&lang=ts&"
export * from "./ChurnTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports